import * as Styled from "./Layout.styles";

import { CRMProvider } from "../../context/CRMContext";
import { CheckMatchProvider } from "context/CheckMatchContext";
import { GDAProvider } from "context/GDAContext";
import Header from "components/Header/Header";
import { LocationFlagsProvider } from "context/LocationFlagsContext";
import { LocationProvider } from "context/LocationContext";
import { Outlet } from "react-router-dom";
import { PartnerProvider } from "context/PartnerContext";
import ProviderTreeBuilder from "context/ProviderTreeBuilder";
import Sidebar from "components/Sidebar/Sidebar";
import { TableStatusProvider } from "context/TableStatusContext";

const ProviderTree = ProviderTreeBuilder([
  [PartnerProvider],
  [LocationProvider],
  [LocationFlagsProvider],
  [TableStatusProvider],
  [CheckMatchProvider],
  [CRMProvider],
  [GDAProvider],
]);

function Layout() {
  return (
    <ProviderTree>
      <Styled.Container>
        {/* <Header /> */}
        <Styled.InnerContainer>
          <Sidebar />
          <Outlet />
        </Styled.InnerContainer>
      </Styled.Container>
    </ProviderTree>
  );
}

export default Layout;
